/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  RequestAllExcelDownloadUrl,
  ResponseDownloadUrl,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RequestAllExcelDownloadUrlFromJSON,
    RequestAllExcelDownloadUrlToJSON,
    ResponseDownloadUrlFromJSON,
    ResponseDownloadUrlToJSON,
} from '../models/index';

export interface DownloadFileApiApiFileDownloadGetRequest {
    path: string;
}

export interface DownloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
    resultFile: string;
    s3Path: string;
}

export interface GenerateAllExcelDownloadUrlApiApiAllExcelBasinIdPostRequest {
    basinId: string;
    tgttime: string;
    requestAllExcelDownloadUrl: RequestAllExcelDownloadUrl;
}

export interface GenerateExcelDownloadUrlApiApiExcelBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
}

export interface GenerateManualDownloadUrlApiApiManualGetRequest {
    path?: string;
}

/**
 * 
 */
export class FileDownloadApi extends runtime.BaseAPI {

    /**
     * オンプレ環境用: ローカルファイルをダウンロードするAPI generate_urlで生成されたURLからこのエンドポイントが呼ばれる
     * Download File Api
     */
    async downloadFileApiApiFileDownloadGetRaw(requestParameters: DownloadFileApiApiFileDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling downloadFileApiApiFileDownloadGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/file/download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * オンプレ環境用: ローカルファイルをダウンロードするAPI generate_urlで生成されたURLからこのエンドポイントが呼ばれる
     * Download File Api
     */
    async downloadFileApiApiFileDownloadGet(requestParameters: DownloadFileApiApiFileDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.downloadFileApiApiFileDownloadGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ただし書き操作移行理由書のダウンロード 対象：利根ダム（高水） https://redmine.riskma.jp/issues/354
     * Download Statement Of Reasons
     */
    async downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGetRaw(requestParameters: DownloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGet().'
            );
        }

        if (requestParameters['resultFile'] == null) {
            throw new runtime.RequiredError(
                'resultFile',
                'Required parameter "resultFile" was null or undefined when calling downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGet().'
            );
        }

        if (requestParameters['s3Path'] == null) {
            throw new runtime.RequiredError(
                's3Path',
                'Required parameter "s3Path" was null or undefined when calling downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        if (requestParameters['resultFile'] != null) {
            queryParameters['resultFile'] = requestParameters['resultFile'];
        }

        if (requestParameters['s3Path'] != null) {
            queryParameters['s3Path'] = requestParameters['s3Path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/downloadStatementOfReasons/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ただし書き操作移行理由書のダウンロード 対象：利根ダム（高水） https://redmine.riskma.jp/issues/354
     * Download Statement Of Reasons
     */
    async downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGet(requestParameters: DownloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.downloadStatementOfReasonsApiDownloadStatementOfReasonsBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 予測処理結果のExcelファイル取得 lambdaを使用してFastApiからから直接zipファイルをダウンロードすると壊れる為 S3へのアップロード後にダウンロード用urlを発行して返す
     * Generate All Excel Download Url Api
     */
    async generateAllExcelDownloadUrlApiApiAllExcelBasinIdPostRaw(requestParameters: GenerateAllExcelDownloadUrlApiApiAllExcelBasinIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDownloadUrl>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling generateAllExcelDownloadUrlApiApiAllExcelBasinIdPost().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling generateAllExcelDownloadUrlApiApiAllExcelBasinIdPost().'
            );
        }

        if (requestParameters['requestAllExcelDownloadUrl'] == null) {
            throw new runtime.RequiredError(
                'requestAllExcelDownloadUrl',
                'Required parameter "requestAllExcelDownloadUrl" was null or undefined when calling generateAllExcelDownloadUrlApiApiAllExcelBasinIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/allExcel/{basinId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestAllExcelDownloadUrlToJSON(requestParameters['requestAllExcelDownloadUrl']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDownloadUrlFromJSON(jsonValue));
    }

    /**
     * 予測処理結果のExcelファイル取得 lambdaを使用してFastApiからから直接zipファイルをダウンロードすると壊れる為 S3へのアップロード後にダウンロード用urlを発行して返す
     * Generate All Excel Download Url Api
     */
    async generateAllExcelDownloadUrlApiApiAllExcelBasinIdPost(requestParameters: GenerateAllExcelDownloadUrlApiApiAllExcelBasinIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDownloadUrl> {
        const response = await this.generateAllExcelDownloadUrlApiApiAllExcelBasinIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 予測処理結果のExcelファイル取得
     * Generate Excel Download Url Api
     */
    async generateExcelDownloadUrlApiApiExcelBasinIdStationIdGetRaw(requestParameters: GenerateExcelDownloadUrlApiApiExcelBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDownloadUrl>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling generateExcelDownloadUrlApiApiExcelBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling generateExcelDownloadUrlApiApiExcelBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling generateExcelDownloadUrlApiApiExcelBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/excel/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDownloadUrlFromJSON(jsonValue));
    }

    /**
     * 予測処理結果のExcelファイル取得
     * Generate Excel Download Url Api
     */
    async generateExcelDownloadUrlApiApiExcelBasinIdStationIdGet(requestParameters: GenerateExcelDownloadUrlApiApiExcelBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDownloadUrl> {
        const response = await this.generateExcelDownloadUrlApiApiExcelBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Manual Download Url Api
     */
    async generateManualDownloadUrlApiApiManualGetRaw(requestParameters: GenerateManualDownloadUrlApiApiManualGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDownloadUrl>> {
        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/manual`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDownloadUrlFromJSON(jsonValue));
    }

    /**
     * Generate Manual Download Url Api
     */
    async generateManualDownloadUrlApiApiManualGet(requestParameters: GenerateManualDownloadUrlApiApiManualGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDownloadUrl> {
        const response = await this.generateManualDownloadUrlApiApiManualGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
